import angular from 'angular';

angular.module('app.ctrls')
    .controller('AdminQueuesController', ['$scope', '$rootScope', 'QueuesService', 'UserService', 'ClusterService', 'DateRangeService', '$state', '$ioAlert', function($scope, $rs, QueuesService, UserService, ClusterService, DateRangeService, $state, $ioAlert) {
        $scope.queues = [];
        $scope.loadFail = false;
        $scope.active = 1;

        var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
            $scope.getQueues(ClusterService.clusterIds[0]);
        });

        $scope.$on('$destroy', function() {
            clusterSelector();
        });

        $scope.getQueues = function(clusterId) {
            QueuesService.getQueues(clusterId, $scope.active).then(function(response) {
                $scope.queues = QueuesService.queues;
            }, function(response) {});
        };

        $scope.editQueue = function(queue) {
            if (queue) {
                $state.go('editAdminQueues', {
                    id: queue.id
                });
            }
        };

        $scope.toggleQueues = function(active){
            $scope.active = active;
            $scope.getQueues(ClusterService.clusterIds[0]);
        };

        $scope.addQueue = function() {
            $state.go('addAdminQueues');
        };

        $scope.updateState = function(queueId) {
            var param = {
                "id": queueId
            };
            QueuesService.toggleState(param).then(function(data) {
                if (data) {
                    $scope.getQueues(ClusterService.clusterIds[0]);
                }
            }, function(error){
                console.log("error updating queues state");
            });
        };

        var init = function() {
            ClusterService.initCluster($rs.userRole);
            DateRangeService.init();
        };

        if ($rs.userRole.id) {
            init();
        } else {
            UserService.getCurrentUserRole().then(function() {
                $rs.userRole = UserService.userRole;
                init();
            }, function() {});
        }
    }]);
